import { useMemo, useState } from "react";
import {
  List,
  TextField,
  WrapperField,
  DatagridConfigurable,
  WithRecord,
  BooleanField,
  BulkDeleteWithConfirmButton,
} from "react-admin";
import MotifAddDialog from "../../components/motifs/create/MotifAddDialog";
import MotifEditDialog from "../../components/motifs/edit/MotifEditDialog";
import motifFilterList from "../../components/motifs/filter/motifFilterList";
import EditBtn from "../../components/editBtn/EditBtn";
import TableListActions from "../../components/tableListActions/TableListActions";
import MotifUploadDialog from "../../components/motifs/upload/MotifUploadDialog";
import TableListActionsWithUpload from "../../components/tableListActions/TableListActionsWithUpload";

const MotifList = () => {
  const [openAdd, setOpenAdd] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [openUpload, setOpenUpload] = useState(false);
  const [recordId, setRecordId] = useState();

  const handleClickOpenAdd = () => {
    setOpenAdd(true);
  };
  const handleClickOpenUpload = () => {
    setOpenUpload(true);
  };
  const handleClickOpenEdit = (recId) => () => {
    setRecordId(recId);
    setOpenEdit(true);
  };
  const list = useMemo(
    () => (
      <List
        empty={false}
        actions={
          <TableListActionsWithUpload
            createHandler={handleClickOpenAdd}
            uploadHandler={handleClickOpenUpload}
            exporter={false}
          />
        }
        filters={motifFilterList}
        queryOptions={{ meta: { sort: ["created_at DESC"] } }} // overide default sort
      >
        <DatagridConfigurable
          bulkActionButtons={<BulkDeleteWithConfirmButton />}
        >
          <TextField source="name" label="mine.label.name" />
          <TextField source="code" label="mine.label.code" />
          <TextField source="brand.name" label="mine.label.brand" />
          <BooleanField
            source="active"
            label="mine.label.active"
            textAlign="center"
          />
          <WrapperField label="mine.label.actions" textAlign="center">
            <WithRecord
              label="author"
              render={(record) => {
                return <EditBtn editHandler={handleClickOpenEdit(record.id)} />;
              }}
            />
          </WrapperField>
        </DatagridConfigurable>
      </List>
    ),
    []
  );
  return (
    <>
      {list}
      <MotifAddDialog open={openAdd} setOpen={setOpenAdd} />
      <MotifEditDialog
        open={openEdit}
        setOpen={setOpenEdit}
        recordId={recordId}
      />
      <MotifUploadDialog open={openUpload} setOpen={setOpenUpload} />
    </>
  );
};

export default MotifList;
